module.exports = __webpack_public_path__ + "img/template_right.c7130975.jpg";